<template>
  <li class="nav-item">
    <el-badge :value="unreadMessageTotal" :max="99" class="item" :hidden="unreadMessageTotal == 0">
      <el-button
        icon="el-icon-chat-round"
        circle
        size="small"
        @click="$bus.$emit('toggle-tenant-messaging', !visible)"
      ></el-button>
    </el-badge>
  </li>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"

export default {
  name: "TenantChatTrigger",
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
    token: {
      required: true,
    },
    tenant: {
      required: true,
    },
    members: {
      type: Array,
      required: true,
    },
    groups: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      viewing: null,
      visible: false,
      messageVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      usersOnline: "chat/usersOnline",
      unreadMessageTotal: "chat/unreadMessageTotal",
    }),
    showUnreadMessageTotal() {
      return true
    },
  },
  watch: {},
  created() {
    this.viewing = Echo.join("viewing." + this.tenant + ".application")
      .here((users) => {
        this.$store.dispatch(
          "chat/usersOnline",
          users.filter((u) => u.id !== this.user.id)
        )
      })
      .joining((user) => {
        this.usersOnline.push(user)
      })
      .leaving((user) => {
        this.$store.dispatch(
          "chat/usersOnline",
          this.usersOnline.filter((u) => u.id !== user.id)
        )
      })

    this.$store.dispatch("chat/setMyself", this.user)
    this.$store.dispatch("chat/setTenant", this.tenant)
    this.$store.dispatch("chat/setMembers", this.members)
    this.$store.dispatch("chat/setGroups", this.groups)
    this.getMessageCount()
  },
  mounted() {
    this.$bus.$on("toggle-tenant-messaging", (value) => {
      this.visible = value
      if (this.visible == false) {
        this.$bus.$emit("toggle-private-message", false)
      }
    })
    this.$bus.$on("toggle-private-message", (value) => {
      this.messageVisible = value
    })
  },
  updated() {
    this.showUnreadMessageTotal
  },
  activated() {},
  methods: {
    getMessageCount() {
          this.$tenant
              .get(`/api/v2/global-messaging-count/${this.user.id}`)
              .then(res => {
                  let count = {}
                  if (_.get(res, 'data') != '') {
                      count = res.data;
                  }
                  this.$store.dispatch("chat/setMessageCount", count)
              })
    },
  },
}
</script>

<style lang="scss">
.app-header.navbar {
  .nav-item {
    transition: 300ms margin ease;

    &.containeropen {
      @media (min-width: 1000px) {
        transition: 500ms margin ease;
        margin: 0 120px 0 0 !important;
      }
    }

    &.messageopen {
      @media (min-width: 1600px) {
        transition: 0ms margin ease;
        margin: 0 720px 0 0 !important;
      }
    }
  }
}
.chat-window {
  margin: 0;
  max-height: 90%;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
}
.messaging-input {
  .input-group {
    input {
      border-radius: 1rem !important;
    }
  }
}

.infinite-loading-container.error {
  display: flex;
  align-items: center;
  height: calc(100% - 100px);
  flex-direction: column;
  justify-content: center;
}
</style>
